import { render, staticRenderFns } from "./Logpass.vue?vue&type=template&id=06bf21b4&"
import script from "./Logpass.vue?vue&type=script&lang=js&"
export * from "./Logpass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports